import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductDeliveryTime extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#updateDeliveryTime);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#updateDeliveryTime);
  }

  #updateDeliveryTime = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDeliveryTime = event.detail.data.html.querySelector('product-delivery-time');
    if (!newDeliveryTime) return;

    morph(this, newDeliveryTime, { childrenOnly: true });

    // Sync display visibility (childrenOnly morph does not update parent attributes)
    const newDisplay = newDeliveryTime.style.display;
    if (newDisplay) {
      this.style.display = newDisplay;
    } else {
      this.style.removeProperty('display');
    }
  };
}

if (!customElements.get('product-delivery-time')) {
  customElements.define('product-delivery-time', ProductDeliveryTime);
}
